export type FilterOption = {
  valueType: FilterOptionValueType;
};

export enum FilterOptionValueType {
  EnumType,
  // Marks the value as a date/timestamp so Equals/NotEquals emit it as an
  // unquoted OData literal (e.g. `dueDateUtc eq 2020-01-01T00:00:00Z`). The
  // call site knows the property is a date; the builder no longer guesses.
  DateType
}
